import styled from 'styled-components'
import { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { db } from '../firebase'
import { push } from 'connected-react-router'
import HTMLReactParser from 'html-react-parser'
import NoProductImage from '../assets/no-product-image.png'
import { Layout, PrimaryButton } from '../components'

const dateToString = (date) => {
    return date.getFullYear() + '-' + 
        ('00' + (date.getMonth()+1)).slice(-2) + '-' + 
        ('00' + date.getDate()).slice(-2) 
}

// 本文の改行表示を有効にする
const compileReturnToBr = (text) => {
    if (text === '') {
        return text
    } else {
        return HTMLReactParser(text.replace(/\r?\n/g, '<br/>'))
    }
}

const NewsDetail = () => {
    const dispatch = useDispatch()
    

    // URLからnewsIdを取得
    const selector = useSelector(state=>state)
    const path = selector.router.location.pathname
    const newsId = path.split('/news/dp/')[1]

    // ニュースを初期化
    const [news, setNews] = useState(null)
    const [image, setImage] = useState(NoProductImage)
    const [date, setDate] = useState(0)

    const postDate = date ? dateToString(date.toDate()) : ''

    // レンダリング後にFirestoreからニュースデータを取得して再レンダリング
    useEffect(() => {
        if(newsId) {
            db.collection('news').doc(newsId).get()
                .then(doc => {
                    const data = doc.data()
                    setNews(data)
                    setImage(data.image ? data.image.path : NoProductImage )
                    setDate(data.created_at)
                })
        }
        return null
    }, [newsId])

    return (
        <Layout>
            { news && (
                <NewsDetailWrapper>
                    <div className='spacer-100'></div>
                    <Title>{news.title}</Title>
                    <div className='spacer-25' />
                    <Date>{postDate}</Date>
                    <div className='spacer-50'></div>
                    <NewsImg src={image} alt={'news'} />
                    <div className='spacer-50'></div>
                    
                    <p>{compileReturnToBr(news.text)}</p>
                    <div className='spacer-50'></div>
                    <ButtonWrapper>
                        <PrimaryButton label="Back to List" operation={()=>dispatch(push('/news'))}/>
                    </ButtonWrapper>
                </NewsDetailWrapper>
            )}
            <div className='spacer-100'></div>
        </Layout>
    )
}

export default NewsDetail

const NewsDetailWrapper = styled.section`
    width: 560px;
    margin: 0 auto;
    p {
        font-size: 18px;
        line-height: 32px;
    }
    @media screen and (max-width:768px){
        width: 100%;
        padding: 0 20px;
    }
`
const Title = styled.h1`
    position: relative;
    &:before {
        position: absolute;
        bottom: -40px;
        left: calc(55% - 300px);
        width: 300px;
        height: 10px;
        content: '';
        background: #fff;
    }
    &:after {
        position: absolute;
        bottom: -50px;
        right: 0;
        width: 55%;
        height: 1px;
        content: '';
        background: #fff;
    }
`

const NewsImg = styled.img`
    width: 560px;
    height: 320px;
    object-fit: cover;
    @media screen and (max-width:768px){
        width: 100%;
    }
`
const Date = styled.div`
    text-align: right;
`
const ButtonWrapper = styled.div`
    text-align: center;
`